module.exports = __webpack_public_path__ + "static/team-karan-telang-e1e2f4bfe3d759d019e9c372f3aad22d.jpeg";